import en from './translations/en.json'
import vn from './translations/vn.json'

export default {
    vn, en
}
